import React, { Fragment } from 'react';
export function UserProductSlide() {
  return <section className="slide" style={{
    backgroundColor: '#0d1520'
  }} data-id="element-402">
      <div className="flex flex-col w-full h-full min-h-0 relative overflow-hidden" data-id="element-403">
        {/* Top text strip */}
        <div className="flex-shrink-0 flex flex-col min-h-0 overflow-hidden" style={{
        padding: 'clamp(1.5rem, 3vw, 3rem) clamp(2rem, 6vw, 6rem) 0'
      }} data-id="element-404">
          {/* Blue italic label */}
          <p className="italic font-semibold animate-fade-slide" style={{
          color: '#4A90D9',
          fontSize: 'var(--body-size)',
          marginBottom: 'clamp(0.3rem, 0.6vw, 0.5rem)',
          animationDelay: '0.1s'
        }} data-id="element-405">
            The product loop.
          </p>

          {/* Heading */}
          <h1 className="font-black tracking-tight leading-[0.95] text-white animate-fade-slide" style={{
          fontSize: 'var(--title-size)',
          animationDelay: '0.15s'
        }} data-id="element-406">
            Our users make it real.
          </h1>
        </div>

        {/* Flow steps — horizontal bar */}
        <div className="flex-shrink-0 animate-fade-slide" style={{
        padding: 'clamp(0.75rem, 1.5vw, 1.25rem) clamp(2rem, 6vw, 6rem)',
        animationDelay: '0.2s'
      }} data-id="element-407">
          <div className="flex items-center justify-center rounded-xl" style={{
          backgroundColor: 'rgba(255,255,255,0.04)',
          border: '1px solid rgba(255,255,255,0.08)',
          padding: 'clamp(0.75rem, 1.5vw, 1.25rem) clamp(1.5rem, 3vw, 3rem)',
          gap: 'clamp(1rem, 2.5vw, 2.5rem)'
        }} data-id="element-408">
            {[{
            step: '01',
            label: 'Discover'
          }, {
            step: '02',
            label: 'Plan'
          }, {
            step: '03',
            label: 'Go'
          }].map((item, i) => <Fragment key={item.step} data-id="element-409">
                {i > 0 && <span style={{
              color: 'rgba(255,255,255,0.25)',
              fontSize: 'clamp(1rem, 2vw, 1.5rem)'
            }} data-id="element-410">
                    →
                  </span>}
                <div className="flex items-baseline" style={{
              gap: 'clamp(0.3rem, 0.6vw, 0.5rem)'
            }} data-id="element-411">
                  <span className="font-mono" style={{
                color: '#4A90D9',
                fontSize: 'var(--small-size)'
              }} data-id="element-412">
                    {item.step}
                  </span>
                  <span className="font-black text-white" style={{
                fontSize: 'clamp(1.5rem, 3.5vw, 2.75rem)',
                letterSpacing: '-0.02em'
              }} data-id="element-413">
                    {item.label}
                  </span>
                </div>
              </Fragment>)}
          </div>
        </div>

        {/* Bottom — two large screenshots side by side */}
        <div className="flex-1 flex items-stretch min-h-0 overflow-hidden" style={{
        padding: '0 clamp(2rem, 6vw, 6rem) clamp(1.5rem, 3vw, 2.5rem)',
        gap: 'clamp(0.75rem, 1.5vw, 1.5rem)'
      }} data-id="element-414">
          {/* Left screenshot — Discovery/Plan */}
          <div className="flex-1 relative animate-fade-slide rounded-xl overflow-hidden" style={{
          animationDelay: '0.3s',
          border: '1px solid rgba(255,255,255,0.08)'
        }} data-id="element-415">
            <img src="https://cdn.magicpatterns.com/uploads/b7HCaed9mfRsTsJHeY7SS9/Screenshot_2026-03-22_at_3.31.42_PM.png" alt="Navi conversational discovery — Hey Navi, take me somewhere new in my city" className="absolute inset-0 w-full h-full object-cover object-top" style={{
            borderRadius: 'clamp(8px, 1vw, 12px)'
          }} data-id="element-416" />
          </div>

          {/* Right screenshot — Navigation */}
          <div className="flex-1 relative animate-fade-slide rounded-xl overflow-hidden" style={{
          animationDelay: '0.4s',
          border: '1px solid rgba(255,255,255,0.08)'
        }} data-id="element-417">
            <img src="https://cdn.magicpatterns.com/uploads/fV1rttr9LJeVj7w22Ro5Ry/Screenshot_2026-03-22_at_3.30.56_PM.png" alt="Navi turn-by-turn navigation with contextual suggestions" className="absolute inset-0 w-full h-full object-cover object-top" style={{
            borderRadius: 'clamp(8px, 1vw, 12px)'
          }} data-id="element-418" />
          </div>
        </div>
      </div>
    </section>;
}